import request from '@/common/request.js';
import { useBaseStore } from "@/stores/base";
const baseStore = useBaseStore();
import { useUserStore } from '@/stores/user'
const userStore = useUserStore()

// 列表项快捷更新
export const getAppointmentListByApi = (params) => {
  return request({
    url: `OSS/index.php?g=health&m=appointment&a=getList`,
    method: 'get',
    params
  })
}

export const getEmployeeListByApi = (params) => {
  return request({
    url: `OSSDCP/health/emp/` + userStore.instId + `/getEmpList`,
    method: 'get',
    headers: {
      domain: baseStore.baseUrl.SocialServiceBaseUrl
    },
    params
  })
}

export const getCourseByInnerApi = (headers = {}) => {
  if (!Object.prototype.hasOwnProperty.call(headers, "domain")) {
    headers = {
      domain: baseStore.baseUrl.SocialServiceBaseUrl
    }
  }

  return request({
    url:`OSSDCP/health/course/getCoursesByInstId`,
    method: 'get',
    params:{
      enable:true,
    },
    headers,
  })
}

export const addAppointmentByApi = (data, headers = {}) => {
  if (!Object.prototype.hasOwnProperty.call(headers, "domain")) {
    headers = {
      domain: baseStore.baseUrl.SocialServiceBaseUrl
    }
  }
  return request({
    url: `OSSDCP/health/appointment`,
    method: 'post',
    headers,
    data
  })
}

export const editAppointmentByApi = (data) => {
  return request({
    url: `OSSDCP/health/appointment`,
    method: 'put',
    headers: {
      domain: baseStore.baseUrl.SocialServiceBaseUrl
    },
    data
  })
}


export const deleteAppointmentByApi = (id) => {
  return request({
    url: `OSSDCP/health/appointment/` + id,
    method: 'delete',
    headers: {
      domain: baseStore.baseUrl.SocialServiceBaseUrl
    }
  })
}

export const getAllowListByApi = (params) => {
  return request({
    url: `OSS/index.php?g=health&m=permission&a=getAllow`,
    method: 'get',
    params
  })
}
// 取消患者预约
export function putAppointmentCancel(params) {
  let id = params.id
  delete params.id
  return request({
    url: `OSSDCP/health/cancel/appointment/${id}`,
    method: 'put',
    headers: {
      domain: baseStore.baseUrl.SocialServiceBaseUrl
    },
    data: params
  })
}

export default {
  getAppointmentListByApi,
  getEmployeeListByApi,
  addAppointmentByApi,
  editAppointmentByApi,
  deleteAppointmentByApi,
  getAllowListByApi,
  putAppointmentCancel,
}
